import Vue from 'vue';
import {
  PARTNER_CREATE_ACTION,
  PARTNER_UPDATE_ACTION,
  PARTNER_LOAD_BY_ID_ACTION,
  PARTNER_STATE_LOAD_ACTION,
  PARTNERS_LOAD_ACTION,
  PARTNER_STATUSES_LOAD_ACTION,
  PARTNER_ARCHIVE_ACTION,
  PARTNER_ENTITIES_LOAD_ACTION
} from '../action-types';
import {
  PARTNER_CREATE_MUTATION,
  PARTNER_UPDATE_MUTATION,
  LOAD_PARTNER_BY_ID_MUTATION,
  PARTNERS_LOAD_MUTATION,
  PARTNER_STATUSES_LOAD_MUTATION,
  PARTNER_ARCHIVE_MUTATION,
  LOAD_PARTNER_STATE_MUTATION,
  PARTNER_ENTITIES_LOAD_MUTATION,
  PARTNER_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION
} from '../mutation-types';
import partnerService from '../../services/api/Partners';

export const namespaced = true;

// initial state
export const state = {
  namespaced: true,
  state: {
    partnerStatus: [],
    partnerState: [],
    sortOrder: false,
    partnerData: [],
    partnerStatusesData: [],    
    partnerEntitiesData: [],
    oldPartnerData:[]    
  },  
};

// mutations
export const mutations = {
  [PARTNER_CREATE_MUTATION](state, partner) {
    state.partnerData.push(partner);
  },
  [PARTNER_UPDATE_MUTATION](state, partner) {
    state.partnerData = state.partnerData.map(partnerStore => {
      if (partnerStore.partnerId === partner.partnerId) {
        return Object.assign({}, partnerStore, partner);
      }
      return partnerStore;
    });
  },
  [LOAD_PARTNER_BY_ID_MUTATION](state, partner) {
    state.partnerData = state.partnerData.map(partnerStore => {
      if(partnerStore.partnerId === partner.partnerId) {
         state.oldPartnerData =JSON.parse(JSON.stringify(partner));
         return Object.assign({}, partnerStore, partner);
      }
      return partnerStore;
    });
  },
  [LOAD_PARTNER_STATE_MUTATION](state, partnerState) {
    Vue.set(state, 'partnerState', [...partnerState]);
  },
  [PARTNERS_LOAD_MUTATION](state, partnerData) {
    Vue.set(state, 'partnerData', [...partnerData]);
  },
  [PARTNER_STATUSES_LOAD_MUTATION](state, partnerStatusesData) {
    Vue.set(state, 'partnerStatusesData', [...partnerStatusesData]);
  },
  [PARTNER_ARCHIVE_MUTATION](state, id) {
    var index = this.state.partners.partnerData.findIndex(
      obj => obj.partnerId == id.partnerId
    );
    this.state.partners.partnerData[index].statusName = 'Archive';
    return this.state.partners.partnerData;
  },
  [PARTNER_ENTITIES_LOAD_MUTATION](state, partnerEntitiesData) {
    Vue.set(state, 'partnerEntitiesData', [...partnerEntitiesData]);
  },
  [PARTNER_AUDIT_LOG_CLEAR_OLD_DATA_MUTATION](state) {
    state.oldPartnerData = null
  },
};

// actions
export const actions = {
  async [PARTNER_LOAD_BY_ID_ACTION]({ dispatch, commit }, partnerID) {
      if (typeof state.partnerData === 'undefined')
        await dispatch(PARTNERS_LOAD_ACTION);
      const response = await partnerService.getPartnerByID(partnerID);
      commit(LOAD_PARTNER_BY_ID_MUTATION, response.data.partnerDetailModel);
      return response.data.partnerDetailModel;
  },
  async [PARTNER_CREATE_ACTION]({ dispatch, commit }, partner) {
      if (typeof state.partnerData === 'undefined')
        await dispatch(PARTNERS_LOAD_ACTION);
      const response = await partnerService.createPartner(partner);
      if(response.data.partnerDetailModel)
         commit(PARTNER_CREATE_MUTATION, response.data.partnerDetailModel);

      return response.data;
  },
  async [PARTNER_UPDATE_ACTION]({ dispatch, commit }, partner) {
      if(typeof state.partnerData === 'undefined')
        await dispatch(PARTNERS_LOAD_ACTION);

      const response = await partnerService.updatePartner(partner);
      if(response.data.partnerDetailModel)
         commit(PARTNER_UPDATE_MUTATION, response.data.partnerDetailModel);

      return response.data;
  },
  async [PARTNER_STATE_LOAD_ACTION]({ commit }) {
      const response = await partnerService.getState();
      commit(LOAD_PARTNER_STATE_MUTATION, response.data);
      return response.data;
  },
  async [PARTNERS_LOAD_ACTION]({ commit }) {
      const response = await partnerService.getPartners();      
      commit(PARTNERS_LOAD_MUTATION, response.data.partnerDetailModel);      
      return response.data.partnerDetailModel;      
  },
  async [PARTNER_STATUSES_LOAD_ACTION]({ commit }) {
      const response = await partnerService.getPartnerStatuses();
      commit(PARTNER_STATUSES_LOAD_MUTATION, response.data);
      return response.data;
  },
  async [PARTNER_ARCHIVE_ACTION]({ commit }, payLoad) {
      var requestData = { PartnerId: payLoad.partnerId, TazClientAuditLog: payLoad.tazClientAuditLog }
      const response = await partnerService.archivePartner(requestData);
      commit(PARTNER_ARCHIVE_MUTATION, response.data.partnerDetailModel);
      return response.data.partnerDetailModel;
  },  
  async [PARTNER_ENTITIES_LOAD_ACTION]({ commit }) {
    const response = await partnerService.getPartnerEntities();
    commit(PARTNER_ENTITIES_LOAD_MUTATION, response.data);      
    return response.data;      
  }
};

export const getters = {
  // For affiliate invitations, we need these statuses only(Active, Inactive, Archive) so that here filtered the status < 4, statusId 4 is Draft
  loadAffiliateInvitationStatuses(){
    return state.partnerStatusesData.filter(r => r.statusID < 4)
  }
}